module.exports = __webpack_public_path__ + "img/img-lamp.e92183b1.png";